import { SortDirection } from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { OrderReadVariables } from "@ticketingplatform/api/dist/order/__generated__/queries";
import { TicketUpdateVariables } from "@ticketingplatform/api/dist/ticket/__generated__/mutations";

export const DEFAULT_TICKET_UPDATE_VARIABLES: Partial<TicketUpdateVariables> = {
  ticketPoolInclude: true,
  eventInclude: true,
  fileInclude: true,
};

export const DEFAULT_ORDER_READ_VARIABLES: Partial<OrderReadVariables> = {
  ...DEFAULT_TICKET_UPDATE_VARIABLES,
  ticketsInclude: true,
  ticketsTake: -1,
  ticketsOrderBy: [{ createdAt: SortDirection.asc }],
  refundsInclude: true,
  refundsTake: -1,
  refundsOrderBy: [{ createdAt: SortDirection.asc }],
  discountCodeInclude: true,
};
